/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
import { AppIdentifierService, AppRefManager } from "fusion-interop-common/src/lifecycle";
import { InteropService, MessageHeaderService, MessageService } from "fusion-interop-common/src/messaging";
import { Pfdc3, pfdc3AgentFactory } from "./publicApi";

/*
 * PFDC3 package
 */
(async () => {
  console.log("------------------------");
  console.log("-- PFDC3 Agent loaded --");
  console.log("------------------------");

  // Create InteropService
  const appIdentifierService = new AppIdentifierService(window);
  const appRefManager = new AppRefManager(window);
  const messageService = new MessageService(window, appRefManager);
  const messageHeaderService = new MessageHeaderService(window);
  const interopService = new InteropService(messageService, messageHeaderService);
  
  const pfdc3 = new Pfdc3(window, interopService, appIdentifierService, appRefManager, pfdc3AgentFactory);
  Object.defineProperty(window, "pfdc3", {
    value: pfdc3,
    configurable: false,
    writable: false,
  });
})();
